import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import classes from './TagSelector.module.css';
import FormDialogue from 'components/UI/FormDialogue/FormDialogue';
import Tag from 'components/UI/Tags/Tag/Tag';

class TagSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterInput: '',
      newTag: '',
      showNewTagCategoryModal: false,
      tagCreated: false,
      listHeight: this.props.type === 'LogsFilter' ? 320 : this.props.shortWindow ? 475.5 : 500,
    };
  }

  componentDidMount() {
    this.setTagsSelectorHeight();
  }

  componentDidUpdate(prevProps) {
    // resize scroll box height when selected giftees changes
    if (
      prevProps.selectedLocationTags !== this.props.selectedLocationTags ||
      prevProps.selectedWhoTags !== this.props.selectedWhoTags ||
      prevProps.selectedWhatTags !== this.props.selectedWhatTags
    ) {
      this.setTagsSelectorHeight();
    }
  }

  setTagsSelectorHeight = () => {
    const selectedTagsContainer = document.getElementById('selectedTags');
    const listHeight =
      this.props.type === 'LogsFilter'
        ? 350 - (selectedTagsContainer !== null ? selectedTagsContainer.clientHeight + 10 : 3)
        : this.props.shortWindow === true
        ? 475.5 - (selectedTagsContainer !== null ? selectedTagsContainer.clientHeight + 10 : 0)
        : this.props.shortWindow === true
        ? selectedTagsContainer
          ? 487 - selectedTagsContainer.clientHeight
          : 487
        : selectedTagsContainer
        ? 565 - selectedTagsContainer.clientHeight
        : 561;
    this.setState({ listHeight });
  };

  handleTagsFilter = (event, reset) => {
    const searchString = reset ? '' : event.target.value.toLowerCase();
    this.setState({ filterInput: searchString });
  };

  addTag = (tag, tagCategory) => {
    this.props.updateTags([tag], [], tagCategory);
    this.setState({ filterInput: '' });
  };

  deleteTag = (tag, tagCategory) => {
    this.props.updateTags([], [tag], tagCategory);
  };

  showNewTagCategorySelector = () => {
    this.setState({ newTag: this.state.filterInput, showNewTagCategoryModal: true });
  };

  handleCategorySelection = (tagCategory) => {
    this.addTag(this.state.newTag, tagCategory);
    this.setState({ showNewTagCategoryModal: false, newTag: '', tagCreated: true });
    this.setState({ filterInput: '' });
  };

  cancelTagCreation = () => {
    this.setState({ showNewTagCategoryModal: false });
  };

  render = () => {
    const tagSelectorClasses = [classes.TagSelector];
    if (this.props.shortWindow === true) tagSelectorClasses.push(classes.ShortWindow);
    if (this.props.type) tagSelectorClasses.push(classes[this.props.type]);
    const selectedWhatTags = this.props.selectedWhatTags.map((tag) => (
      <span
        key={`${tag}-what`}
        className={[classes.Tag, classes.SelectedTag, classes.WhatTag].join(' ')}
        onClick={() => this.deleteTag(tag, 'whatTags')}
      >
        {tag}
        <FontAwesomeIcon icon="times" className={classes.UnselectTag} />
      </span>
    ));

    const selectedLocationTags = this.props.selectedLocationTags.map((tag) => (
      <span
        key={`${tag}-location`}
        className={[classes.Tag, classes.SelectedTag, classes.LocationTag].join(' ')}
        onClick={() => this.deleteTag(tag, 'locationTags')}
      >
        {tag}
        <FontAwesomeIcon icon="times" className={classes.UnselectTag} />
      </span>
    ));

    const selectedWhoTags = this.props.selectedWhoTags.map((tag) => (
      <span
        key={`${tag}-people`}
        className={[classes.Tag, classes.SelectedTag, classes.WhoTag].join(' ')}
        onClick={() => this.deleteTag(tag, 'whoTags')}
      >
        {tag}
        <FontAwesomeIcon icon="times" className={classes.UnselectTag} />
      </span>
    ));

    const filteredWhatTags = this.props.whatTagsList.filter((tag) => tag.includes(this.state.filterInput)).sort();
    const filteredWhoTags = this.props.whoTagsList.filter((tag) => tag.includes(this.state.filterInput)).sort();
    const filteredLocationTags = this.props.locationTagsList.filter((tag) => tag.includes(this.state.filterInput)).sort();

    const whatTags =
      filteredWhatTags.length > 0
        ? filteredWhatTags.map((tag, i) => <Tag tagType="WhatTag" key={tag + i} tag={tag} clicked={() => this.addTag(tag, 'whatTags')} />)
        : null;

    const locationTags =
      filteredLocationTags.length > 0
        ? filteredLocationTags.map((tag, i) => <Tag tagType="LocationTag" tag={tag} key={tag + i} clicked={() => this.addTag(tag, 'locationTags')} />)
        : null;

    const whoTags =
      filteredWhoTags.length > 0
        ? filteredWhoTags.map((tag, i) => <Tag tagType="WhoTag" tag={tag} key={tag + i} clicked={() => this.addTag(tag, 'whoTags')} />)
        : null;

    const createNewTag =
      this.state.filterInput.length > 0 && this.props.readOnly !== true ? (
        <span className={[classes.Tag, classes.CreateNewTag].join(' ')} onClick={this.showNewTagCategorySelector}>
          <FontAwesomeIcon icon="plus" className={classes.Icon} />
          <span>CREATE NEW TAG: </span>
          <span>{this.state.filterInput}</span>
        </span>
      ) : null;

    const tagCategorySelectionDialogue = this.state.showNewTagCategoryModal ? (
      <FormDialogue
        show={this.state.showNewTagCategoryModal === true}
        className="tagCategorySelectionContribute"
        title="TAG TYPE"
        desc="What type of tag would you say this is?"
        cancelled={this.cancelTagCreation}
      >
        <div onClick={() => this.handleCategorySelection('whatTags')} className={classes.TagCategory}>
          General
        </div>
        <div onClick={() => this.handleCategorySelection('locationTags')} className={classes.TagCategory}>
          Location
        </div>
        <div onClick={() => this.handleCategorySelection('whoTags')} className={classes.TagCategory}>
          People
        </div>
        <div onClick={this.cancelTagCreation} className={classes.TagCategory}>
          Cancel
        </div>
      </FormDialogue>
    ) : null;
    return (
      <div className={tagSelectorClasses.join(' ')}>
        {tagCategorySelectionDialogue}
        <div className={classes.TagsFilterContainer}>
          <input
            className={classes.TagsFilterInput}
            placeholder={this.props.placeholder ? this.props.placeholder : 'Enter a tag'}
            onChange={(e) => this.handleTagsFilter(e)}
            value={this.state.filterInput}
          />
        </div>
        <div id="selectedTags" style={{ display: 'block', minHeight: '30px' }}>
          {this.state.filterInput.length === 0 &&
          this.state.tagCreated === false &&
          selectedWhatTags.length === 0 &&
          selectedLocationTags.length === 0 &&
          selectedWhoTags.length === 0 ? (
            <p className={classes.TagFilterPrompt}>Write your own and/or pick from the tags below.</p>
          ) : (
            <div className={classes.SelectedTags}>
              {selectedWhatTags}
              {selectedLocationTags}
              {selectedWhoTags}
            </div>
          )}
        </div>
        <hr className={classes.TagSectionDivider} />
        <div className={classes.TagContainer} style={{ height: `${this.state.listHeight}px` }}>
          {whatTags ? (
            <div className={classes.TagSection}>
              <h4 className={classes.TagSectionLabel}>General Tags</h4>
              {whatTags}
            </div>
          ) : null}
          {locationTags ? (
            <div className={classes.TagSection}>
              <h4 className={classes.TagSectionLabel}>Location Tags</h4>
              {locationTags}
            </div>
          ) : null}
          {whoTags ? (
            <div className={classes.TagSection}>
              <h4 className={classes.TagSectionLabel}>People Tags</h4>
              {whoTags}
            </div>
          ) : null}
          {createNewTag}
        </div>
      </div>
    );
  };
}

export default TagSelector;
